/* eslint-disable max-len */
import React from 'react'
import { string } from 'prop-types'

function PrintModels(props) {
  return (
    <svg
      {...props}
      width="23"
      height="20"
      viewBox="0 0 23 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.25049 18.25H10.7505V15.75H5.50049V14.25H17.5005V15.75H12.2505V18.25H19.7505V7H21.2505V19C21.2505 19.4142 20.9146 19.7499 20.5005 19.75H2.50049C2.08627 19.75 1.75049 19.4142 1.75049 19V7H3.25049V18.25ZM11.5005 0.25C12.8483 0.250062 13.9673 1.22019 14.2026 2.5H22.5005V4H14.0601C13.8371 4.57023 13.4296 5.04518 12.9106 5.35645L12.0005 9H11.0532L10.0952 5.36035C9.57365 5.04919 9.16465 4.57221 8.94092 4H0.500488V2.5H8.79736C9.03261 1.22009 10.1526 0.25 11.5005 0.25ZM11.5005 1.75C10.8101 1.75 10.2505 2.30964 10.2505 3C10.2505 3.69036 10.8101 4.25 11.5005 4.25C12.1908 4.24993 12.7505 3.69031 12.7505 3C12.7505 2.30969 12.1908 1.75007 11.5005 1.75Z"
        fill="currentColor"
      />
      <path
        d="M3.25049 18.25H10.7505V15.75H5.50049V14.25H17.5005V15.75H12.2505V18.25H19.7505V7H21.2505V19C21.2505 19.4142 20.9146 19.7499 20.5005 19.75H2.50049C2.08627 19.75 1.75049 19.4142 1.75049 19V7H3.25049V18.25ZM11.5005 0.25C12.8483 0.250062 13.9673 1.22019 14.2026 2.5H22.5005V4H14.0601C13.8371 4.57023 13.4296 5.04518 12.9106 5.35645L12.0005 9H11.0532L10.0952 5.36035C9.57365 5.04919 9.16465 4.57221 8.94092 4H0.500488V2.5H8.79736C9.03261 1.22009 10.1526 0.25 11.5005 0.25ZM11.5005 1.75C10.8101 1.75 10.2505 2.30964 10.2505 3C10.2505 3.69036 10.8101 4.25 11.5005 4.25C12.1908 4.24993 12.7505 3.69031 12.7505 3C12.7505 2.30969 12.1908 1.75007 11.5005 1.75Z"
        fill="url(#paint0_radial_2541_2268)"
        fillOpacity="0.5"
      />
      <defs>
        <radialGradient
          id="paint0_radial_2541_2268"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(1.6116 4.35706) rotate(1.90625) scale(36.409 13.2979)"
        >
          <stop stopColor="#01ECFF" />
          <stop offset="1" stopColor="#497FFF" />
        </radialGradient>
      </defs>
    </svg>
  )
}

PrintModels.propTypes = {
  className: string,
  height: string,
  width: string,
}

export default PrintModels
